import script from "./DomainModelAggregateRoot.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainModelAggregateRoot.vue?vue&type=script&setup=true&lang=js"

import "./DomainModelAggregateRoot.vue?vue&type=style&index=0&id=1d9fbeb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d9fbeb6"]])

export default __exports__